import { getQaSelector } from '../../../../utils/common'
import Text from '../../../Text'

import * as styles from './EmailPreviewTextField.module.css'

function EmailPreviewTextField({ label, qaName, value }) {
  const qaProps = getQaSelector({
    value: qaName,
  })

  return (
    <div {...qaProps} className={styles.field}>
      <Text isSecondary>{label}</Text>
      <Text>{value}</Text>
    </div>
  )
}

export default EmailPreviewTextField
